import ResponsiveHelper from "../utils/ResponsiveHelper";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class SingleTopic {
  constructor(dom, threeCanvas) {
    this.dom = dom;
    this.threeCanvas = threeCanvas
    this.threeCanvas.focusModel(this.dom.dataset.slug, () => {
      gsap.to(this.threeCanvas.parentDOM, { opacity: 1 })
      gsap.to(this.dom, {
        opacity: 1,
      })
    })
    // gsap.to(this.dom, {
    //   opacity: 1,
    // })
    // this.collapseElementList = document.querySelectorAll('.collapse')
    // this.collapseElementList.forEach((item, i) => {
    //   item.addEventListener('shown.bs.collapse', event => {
    //     // console.log('shown');
    //     ScrollTrigger.getById('single-ques').refresh()
    //   })
    // });

    window.addEventListener("resize", () => this.resize());
  }

  async init() {
    this.initResponsiveHelper();

    let _this = this

    ScrollTrigger.matchMedia({
      "(min-width: 769px)": function () {
        gsap.to(_this.threeCanvas.parentDOM, { opacity: 1 })
        // console.log('d');
        ScrollTrigger.create({
          trigger: _this.dom.querySelector('.left--wrap'),
          start: "top 115px",
          end: () => {
            let h = _this.dom.querySelector('.right').offsetHeight - _this.dom.querySelector('.left--wrap').offsetHeight
            // console.log(h);
            return `+=${h}`
          },
          pin: true,
          // markers: true,
        });
      },
      "(max-width: 768px)": function () {
        gsap.to(_this.threeCanvas.parentDOM, { opacity: 1 })
        // ScrollTrigger.create({
        //   trigger: _this.dom.querySelector('.right'),
        //   start: "top 50%",
        //   end: () => ScrollTrigger.maxScroll(window) - 1,
        //   onEnter: () => {
        //     console.log('onEnter');
        //     gsap.to(_this.threeCanvas.parentDOM, { opacity: .3 })
        //   },
        //   onLeaveBack: () => {
        //     gsap.to(_this.threeCanvas.parentDOM, { opacity: 1 })
        //   },
        //   markers: true,
        //   invalidateOnRefresh: 1
        // });

        window.addEventListener("scroll", _this.handleMobileScroll, false)

      },
    })
  }

  handleMobileScroll() {
    let r = document.querySelector('#single-topic .right')
    let q_cb = document.querySelector('.ques-callback')
    // console.log(r.offsetTop, window.scrollY);
    // if (r.offsetTop - window.scrollY < 200 ) {
    if (r.getBoundingClientRect().top < window.innerHeight * .7 &&  q_cb.getBoundingClientRect().top > 50) {
      gsap.to(document.querySelector('#appBg'), { opacity: .3 })
    } else {
      gsap.to(document.querySelector('#appBg'), { opacity: 1 })
    }
  }

  initResponsiveHelper() {

  }

  resize() {
  }

  destory() {
    window.removeEventListener("scroll", this.handleMobileScroll, false)
  }
}
